import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { TipoSincronizacao } from '../../services/sincronizacao';

interface SelectTipoSincronizacaoProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

const SelectTipoSincronizacao: React.FC<SelectTipoSincronizacaoProps> = ({ value, onChange }) => {
  const tipos: TipoSincronizacao[] = [
    { Id: 1, Nome: 'Todas' },
    { Id: 2, Nome: 'Vendedor' },
    { Id: 3, Nome: 'Nota saída' },
    { Id: 4, Nome: 'Nota retorno' },
    { Id: 5, Nome: 'Pagamento' },
  ];

  return (
    <FormControl fullWidth style={{ marginRight: '8px' }}>
      <InputLabel>Sincronizações</InputLabel>
      <Select
        value={value || ''}
        label="Sincronizações"
        onChange={(e) => onChange(e.target.value as number | null)}
      >
        {tipos.map((tipo) => (
          <MenuItem key={tipo.Id} value={tipo.Id}>
            {tipo.Nome}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectTipoSincronizacao;
